export const STATUS_DRAFT = 'draft';
export const STATUS_SUBMITTED = 'submitted';

export const LIFELINE_MATERIALS = ['Wire', 'Stainless Steel', 'Galvanized Steel', 'Synthetic'];

// SRD tool filter — matches Type values in external [DH_Griffin].[dbo].[ToolInventory].
// Both spellings supported (legacy data may use either).
export const SRD_TOOL_FILTERS = ['retractable lifeline', 'retractable life line'];

/**
 * Группы секций — на форме рендерятся как два визуальных блока:
 *   1) "Inspect the unit"          → connectors + housing + shockPack
 *   2) "Verify Lifeline Operation" → lifelineOperation
 */
export const INSPECTION_GROUPS = [
    { id: 'inspectUnit',     title: 'Inspect the unit',          color: '#37474f', sections: ['connectors', 'housing', 'shockPack'] },
    { id: 'verifyLifeline',  title: 'Verify Lifeline Operation', color: '#01579b', sections: ['lifelineOperation'] },
];

export const INSPECTION_SECTIONS = {
    connectors: {
        title: 'Connectors',
        color: '#b71c1c',
        items: [
            { key: 'connectorsLatch',     label: 'Latches function properly (self-closing / locking)' },
            { key: 'connectorsCorrosion', label: 'No corrosion or nicks, all hardware intact' },
        ]
    },
    housing: {
        title: 'Housing',
        color: '#4a148c',
        items: [
            { key: 'housingLabels',       label: 'Labels & QR code (if present) intact & legible' },
            { key: 'housingMarkings',     label: 'Appropriate ANSI / OSHA / CSA markings' },
            { key: 'housingCorrosion',    label: 'No corrosion, cracks or nicks, all hardware intact' },
        ]
    },
    shockPack: {
        title: 'Shock Pack (if present)',
        color: '#e65100',
        items: [
            { key: 'shockPackCover',      label: 'Cover / shrink tubing intact & no cuts' },
            { key: 'shockPackDamage',     label: 'No damage, fraying or broken stitching' },
        ]
    },
    lifelineOperation: {
        title: 'Verify Lifeline Operation',
        color: '#01579b',
        items: [
            { key: 'lifelineLockTest',     label: 'Slowly pull out the lifeline. Every 5 ft pull hard / jerk to verify locking mechanism functions properly' },
            { key: 'lifelineWebInspection',label: 'At full extension, work back to the housing visually inspecting cable / web for frays, burns, kinks, etc.' },
            { key: 'lifelineRetraction',   label: 'Slowly and smoothly allow the lifeline to fully retract' },
        ]
    }
};

// All check item keys for overall result calculation
export const ALL_CHECK_KEYS = Object.values(INSPECTION_SECTIONS)
    .flatMap(section => section.items.map(item => item.key));
